import { useTranslation } from 'react-i18next';

const TestimonialsSection = () => {
  const { t } = useTranslation();
  
  const testimonials = [
    {
      id: 1,
      name: 'Sophie Martin',
      location: 'Paris, France',
      rating: 5,
      comment: 'Service exceptionnel ! Notre chauffeur était ponctuel, courtois et connaissait parfaitement les routes. Le véhicule était impeccable et très confortable.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20elegant%20French%20woman%20in%20her%2040s%2C%20sophisticated%20traveler%2C%20warm%20smile%2C%20business%20casual%20attire%2C%20confident%20and%20satisfied%20customer%2C%20natural%20lighting%2C%20professional%20headshot%20style&width=100&height=100&seq=sophie-martin&orientation=squarish'
    },
    {
      id: 2,
      name: 'Ahmed El Mansouri',
      location: 'Casablanca, Maroc',
      rating: 5,
      comment: 'Parfait pour mes déplacements professionnels. Toujours à l\'heure, service discret et véhicules de qualité. Je recommande vivement !',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Moroccan%20businessman%20in%20his%2050s%2C%20elegant%20suit%2C%20confident%20expression%2C%20successful%20entrepreneur%2C%20warm%20and%20trustworthy%20appearance%2C%20professional%20business%20photography&width=100&height=100&seq=ahmed-mansouri&orientation=squarish'
    },
    {
      id: 3,
      name: 'Emily Johnson',
      location: 'Toronto, Canada',
      rating: 5,
      comment: 'Notre voyage au Maroc a été magique grâce à cette équipe. Ils ont organisé un circuit personnalisé absolument parfait. Une expérience inoubliable !',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Canadian%20woman%20in%20her%2030s%2C%20friendly%20smile%2C%20casual%20elegant%20style%2C%20happy%20traveler%2C%20natural%20and%20approachable%20appearance%2C%20outdoor%20natural%20lighting&width=100&height=100&seq=emily-johnson&orientation=squarish'
    },
    {
      id: 4,
      name: 'Jean-Pierre Dubois',
      location: 'Montréal, Canada',
      rating: 5,
      comment: 'Service impeccable du début à la fin. L\'équipe est très professionnelle et les tarifs sont transparents. Aucune surprise, que du bonheur !',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Canadian%20man%20in%20his%2060s%2C%20distinguished%20appearance%2C%20gray%20hair%2C%20warm%20smile%2C%20business%20casual%20attire%2C%20experienced%20traveler%2C%20professional%20photography&width=100&height=100&seq=jean-pierre-dubois&orientation=squarish'
    },
    {
      id: 5,
      name: 'Fatima Zahra',
      location: 'Rabat, Maroc',
      rating: 5,
      comment: 'Excellent service pour nos invités étrangers. Ils ont été très impressionnés par le professionnalisme et la qualité de l\'accueil.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20elegant%20Moroccan%20woman%20in%20her%2040s%2C%20traditional%20modern%20style%2C%20confident%20and%20warm%20expression%2C%20business%20professional%2C%20sophisticated%20appearance%2C%20natural%20lighting&width=100&height=100&seq=fatima-zahra&orientation=squarish'
    },
    {
      id: 6,
      name: 'Marco Rossi',
      location: 'Milan, Italie',
      rating: 5,
      comment: 'Fantastico! Le service était parfait pour notre lune de miel au Maroc. Véhicule luxueux et chauffeur très attentionné. Merci pour ces moments magiques !',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Italian%20man%20in%20his%2030s%2C%20stylish%20appearance%2C%20warm%20smile%2C%20romantic%20traveler%2C%20elegant%20casual%20style%2C%20Mediterranean%20features%2C%20natural%20professional%20photography&width=100&height=100&seq=marco-rossi&orientation=squarish'
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-charcoal-800 mb-4 sm:mb-6">
            {t('common:testimonialsTitle')}
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-charcoal-600 max-w-3xl mx-auto leading-relaxed px-4">
            {t('common:testimonialsDescription')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-sand-50 rounded-2xl p-4 sm:p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              {/* Étoiles */}
              <div className="flex items-center mb-3 sm:mb-4">
                {[...Array(testimonial.rating)].map((_, index) => (
                  <i key={index} className="ri-star-fill text-gold-500 text-base sm:text-lg"></i>
                ))}
              </div>

              {/* Commentaire */}
              <p className="text-charcoal-600 mb-4 sm:mb-6 leading-relaxed italic text-sm sm:text-base">
                "{testimonial.comment}"
              </p>

              {/* Profil client */}
              <div className="flex items-center">
                <div>
                  <h4 className="font-semibold text-charcoal-800 text-sm sm:text-base">{testimonial.name}</h4>
                  <p className="text-xs sm:text-sm text-charcoal-500">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Statistiques */}
        <div className="mt-12 sm:mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 md:gap-8 text-center">
          <div className="bg-gold-50 rounded-lg p-4 sm:p-6">
            <div className="text-2xl sm:text-3xl font-bold text-gold-600 mb-1 sm:mb-2">500+</div>
            <div className="text-charcoal-600 text-xs sm:text-sm md:text-base">{t('common:satisfiedClients')}</div>
          </div>
          <div className="bg-gold-50 rounded-lg p-4 sm:p-6">
            <div className="text-2xl sm:text-3xl font-bold text-gold-600 mb-1 sm:mb-2">10+</div>
            <div className="text-charcoal-600 text-xs sm:text-sm md:text-base">{t('common:yearsExperience')}</div>
          </div>
          <div className="bg-gold-50 rounded-lg p-4 sm:p-6">
            <div className="text-2xl sm:text-3xl font-bold text-gold-600 mb-1 sm:mb-2">50+</div>
            <div className="text-charcoal-600 text-xs sm:text-sm md:text-base">{t('common:destinations')}</div>
          </div>
          <div className="bg-gold-50 rounded-lg p-4 sm:p-6">
            <div className="text-2xl sm:text-3xl font-bold text-gold-600 mb-1 sm:mb-2">24/7</div>
            <div className="text-charcoal-600 text-xs sm:text-sm md:text-base">{t('common:customerService')}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
